var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 198.732,
    height: 200,
    viewBox: "0 0 198.732 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 11.898,
    y: 29.248,
    width: 174.105,
    height: 139.39,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 127.403,
    y: 77.878,
    width: 47.557,
    height: 46.338,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "e"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 127.411,
    y: 118.176,
    width: 47.557,
    height: 46.32,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "g"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "g"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 121.26,
    y: 35.474,
    width: 49.86,
    height: 46.252,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    x: 56.789,
    y: 80.821,
    width: 81.551,
    height: 81.573,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "k"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "k"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    x: 74.523,
    y: 88.041,
    width: 45.836,
    height: 64.629,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "m"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "m"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 22.223,
    y: 78.782,
    width: 47.56,
    height: 46.343,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "o"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "o"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "p",
    x: 22.226,
    y: 118.185,
    width: 47.563,
    height: 46.315,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "q"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "q"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.693)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46.693)",
    stroke: "#fff",
    strokeWidth: 4,
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.366,
    cy: 100,
    rx: 99.366,
    ry: 100,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.366,
    cy: 100,
    rx: 97.366,
    ry: 98,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.551 44.494)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.14, -44.49)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.485-282.247H156.612c-1.889,0-1.9,0-1.9-1.953q0-26.293.01-52.589c.007-3.59-1.081-6.975-1.733-10.439-.981-5.213-2.079-10.4-3.167-15.593-.228-1.086-.059-1.577,1.174-1.828q30-6.122,59.97-12.341,25.334-5.233,50.661-10.47c5.78-1.194,11.571-2.35,17.341-3.6,1.16-.254,1.519.118,1.73,1.166q3.325,16.552,6.7,33.09,2.88,14.2,5.77,28.393c.39,1.9.4,1.9-1.444,2.3-3.526.766-3.526.766-3.526,4.339q0,18.85,0,37.7c0,1.825,0,1.832-1.848,1.832Zm-.031-3.471H282.73c2.054,0,2.058,0,2.058-2.068V-342.97c0-.216-.017-.435,0-.648.086-.975-.283-1.48-1.316-1.382-.425.042-.853.007-1.281.007q-57.039,0-114.074.014c-2.818,0-5.639-.018-8.463.115-1.485.07-1.506.53-1.506,1.637q.031,27.787.014,55.573c0,1.933,0,1.936,1.889,1.936Zm44.77-62.7c6,0,11.993-.035,17.987.024,1.243.014,1.43-.39,1.2-1.508q-3.693-17.926-7.3-35.872c-.273-1.354-.794-1.515-2.01-1.257q-15.762,3.332-31.547,6.564-33.316,6.884-66.635,13.747-11.442,2.361-22.894,4.676c-1.057.213-1.509.519-1.233,1.745.8,3.576,1.505,7.173,2.179,10.777a1.154,1.154,0,0,0,1.519,1.086c1.057-.16.529-.943.442-1.414-.57-3.054-1.167-6.1-1.83-9.133-.2-.94.027-1.33.96-1.518,4.783-.961,9.555-1.971,14.334-2.956.328-.066.791-.219.967.094a4.621,4.621,0,0,1,.594,2.6c-.059.7-.842.623-1.354.732-3.429.738-6.865,1.466-10.3,2.145-1.008.2-1.488.481-1.167,1.7a55.794,55.794,0,0,1,1.271,6.205c.19,1.281.77,1.588,1.965,1.584q15.612-.057,31.22.007c1.24.007,1.685-.38,1.892-1.6a25.488,25.488,0,0,1,34.031-19.52c8.871,3.43,14.161,9.966,16.212,19.245.4,1.825.338,1.842,2.155,1.842Q257.553-348.421,266.224-348.423Zm-51.724.007a1.017,1.017,0,0,0-.135-.313c-2.393-2.458-1.765-7.361,1.167-9.565,1.229-.923,1.678-1.744,1.115-3.175-.152-.379-.421-1.013.117-1.3a4.052,4.052,0,0,1,2.445-.62c.791.125.653,1.048.739,1.63a1.561,1.561,0,0,0,1.7,1.511,10.42,10.42,0,0,1,3.277.554c.318.121.8.163.839.5a4.988,4.988,0,0,1-.843,2.525c-.276.613-.808.268-1.243.16-2-.491-3.978-.654-5.822.543-2,1.292-2.262,4.318-.411,5.216a23.83,23.83,0,0,0,9.382,2.441c5.124.216,10.266.032,15.4.08,1.126.01,1.357-.289,1.136-1.417a22.239,22.239,0,0,0-26.858-17.466c-8.653,2.061-15.484,9.262-16.8,17.622-.166,1.052.121,1.264,1.081,1.257,4.323-.038,8.647-.017,12.97-.021C214-348.253,214.272-348.162,214.5-348.416Z",
    transform: "translate(-122.6 435.63)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.14, -44.49)",
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.973-377.313c2.4,0,4.794.028,7.191-.01.946-.017,1.292.363,1.285,1.288-.021,4.411-.038,8.822.011,13.229.014,1.423-.884,1.278-1.8,1.306-.96.027-1.668-.062-1.647-1.33.048-3.212-.031-6.425.035-9.633.028-1.2-.3-1.655-1.575-1.627-3.551.08-7.108-.017-10.659.048-1.223.024-1.43-.552-1.409-1.561.017-.967-.007-1.779,1.378-1.73C187.176-377.254,189.576-377.313,191.973-377.313Z",
    transform: "translate(-40.75 470.46)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.14, -44.49)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.909-350.135c-2.394,0-4.791-.059-7.185.024-1.319.045-1.316-.722-1.319-1.641s.017-1.672,1.316-1.651c3.634.059,7.271-.01,10.9.038,1.054.014,1.43-.328,1.413-1.4-.052-3.205-.028-6.414-.01-9.62.007-1.42.18-1.5,1.831-1.547,1.109-.035,1.62.28,1.6,1.513-.062,4.276-.052,8.552-.007,12.828.014,1.123-.373,1.5-1.492,1.472C196.614-350.18,194.262-350.135,191.909-350.135Z",
    transform: "translate(-40.74 499.36)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.14, -44.49)",
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.609-373.6c-.87.152-.846-.553-.95-1.054-.663-3.136-1.33-6.272-1.92-9.419-.2-1.088-.508-1.53-1.762-1.237-3.5.808-7.036,1.42-10.542,2.2-1.009.225-1.392-.041-1.589-1.005-.432-2.114-.452-2.1,1.623-2.5,4.359-.856,8.722-1.7,13.07-2.632,1.129-.242,1.606-.01,1.831,1.164.808,4.238,1.717,8.459,2.573,12.69C201.231-373.989,200.716-373.6,198.609-373.6Z",
    transform: "translate(-45.14 440.06)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.14, -44.49)",
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.2-351.017a25.5,25.5,0,0,1-25.518,25.346A25.813,25.813,0,0,1,163.15-351.39a25.486,25.486,0,0,1,25.615-25.353A25.6,25.6,0,0,1,214.2-351.017Zm-3.478-.186a22.035,22.035,0,0,0-21.978-22.265,22.053,22.053,0,0,0-22.189,22.051,21.954,21.954,0,0,0,21.926,22.282A21.885,21.885,0,0,0,210.723-351.2Z",
    transform: "translate(-91.11 472.82)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.14, -44.49)",
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.6-340.562c-1.074.2-1.337-.439-1.344-1.489-.014-2.532-.042-2.545-2.473-3.088a16.018,16.018,0,0,1-2.549-.86,1.2,1.2,0,0,1-.8-1.789c.636-1.713.58-1.731,2.249-1.012a10.663,10.663,0,0,0,5.26.888,4.144,4.144,0,0,0,3.8-2.949,4,4,0,0,0-1.827-4.2c-1.862-1.336-4.138-1.837-6.072-3.05-3.554-2.228-4.515-6.065-2.259-9.371a6.781,6.781,0,0,1,3.837-2.646,1.317,1.317,0,0,0,1.1-1.578c-.031-.428-.007-.857,0-1.285.021-1.572.159-1.658,1.685-1.662.978-.007,1.226.435,1.244,1.326.042,2.473.069,2.47,2.449,3.026a10.448,10.448,0,0,1,1.112.307c1.813.635,1.827.788,1.185,2.566-.38,1.057-.867,1.109-1.817.7a8.33,8.33,0,0,0-5.637-.577,3.1,3.1,0,0,0-2.4,2.414,3.156,3.156,0,0,0,1.223,3.305,11.945,11.945,0,0,0,2.915,1.606,23.825,23.825,0,0,1,3.482,1.637,7.037,7.037,0,0,1,3.62,7.247,6.693,6.693,0,0,1-4.963,5.8c-1.178.39-1.6.939-1.437,2.1a8.008,8.008,0,0,1,.007,1.154C177.152-340.656,177.062-340.566,175.6-340.562Z",
    transform: "translate(-78.52 477.95)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.14, -44.49)",
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.273-377.315c2.4,0,4.8.052,7.195-.017,1.3-.038,1.326.718,1.323,1.647s-.014,1.665-1.326,1.641c-3.6-.069-7.2.014-10.794-.045-1.109-.017-1.506.3-1.482,1.447.066,3.208-.035,6.424.048,9.637.035,1.368-.632,1.53-1.734,1.513-1.06-.01-1.8-.069-1.772-1.482.072-4.283.059-8.566,0-12.849-.017-1.223.47-1.541,1.6-1.509C156.645-377.27,158.959-377.315,161.273-377.315Z",
    transform: "translate(-115.26 471.37)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.14, -44.49)",
    filter: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.274-350.142c-2.4,0-4.794-.034-7.191.018-1.016.021-1.347-.373-1.34-1.354.028-4.366.048-8.732-.01-13.1-.017-1.388.8-1.35,1.758-1.35s1.768-.017,1.741,1.364c-.073,3.126-.024,6.248-.021,9.375,0,1.8,0,1.8,1.855,1.8,3.423,0,6.849.052,10.272-.028,1.313-.028,1.457.618,1.457,1.658s-.145,1.7-1.461,1.644C165.985-350.207,163.626-350.142,161.274-350.142Z",
    transform: "translate(-115.26 499.36)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/Money.5febdebce54cb2b7e6fdbf63695502ab.svg";
export { ForwardRef as ReactComponent };